import {create} from "zustand";
import {LocationType} from "./types";

export type LocationStoreState = {
    location: LocationType;
    loading: boolean;

    actions: {
        setLocation: (location: LocationType) => void;
        setLoading: (loading: boolean) => void;
    };
};

export const locationStore = create<LocationStoreState>((set) => ({
    location: {
        city: "Москва",
        country: "Россия",
        geo_lat: "55.755819",
        geo_lon: "37.617644",
        region: "Москва",
    },
    loading: false,

    actions: {
        setLocation: (location) => set({location}),
        setLoading: (loading) => set({loading}),
    },
}));
